import AwardBadgeButtonContainer from './AwardBadgeButton.container';
import AwardBadgeButton from './AwardBadgeButton';
export default AwardBadgeButtonContainer(AwardBadgeButton);
